module.exports = __webpack_public_path__ + "static/media/sort-shapes-up.f9955d1a.svg";